const CONST = {
    'SET_CONFIG':'ROSTER_JOBS/SET_CONFIG',
    'FETCH_JOBS_SUCCESS':'ROSTER_JOBS/FETCH_JOBS_SUCCESS',
    'FETCH_JOBS_FAILED':'ROSTER_JOBS/FETCH_JOBS_FAILED',
    'FETCH_FAILED_JOBS_SUCCESS':'ROSTER_JOBS/FETCH_FAILED_JOBS_SUCCESS',
    'FETCH_FAILED_JOBS_FAILED':'ROSTER_JOBS/FETCH_FAILED_JOBS_FAILED',
    'MANUAL_RUN_SUCCESS':'ROSTER_JOBS/MANUAL_RUN_SUCCESS',
    'MANUAL_RUN_FAILED':'ROSTER_JOBS/MANUAL_RUN_FAILED',
}

export default CONST;

